import { render, staticRenderFns } from "./AddDocumentNew.vue?vue&type=template&id=4f850426&"
import script from "./AddDocumentNew.vue?vue&type=script&lang=js&"
export * from "./AddDocumentNew.vue?vue&type=script&lang=js&"
import style0 from "./AddDocumentNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports